import { createContext, useContext, useState, useCallback } from 'react';

const PageLoadingContext = createContext();

export function PageLoadingProvider({ children }) {
  const [loadingCount, setLoadingCount] = useState(0);

  const startLoading = useCallback(() => {
    setLoadingCount((c) => c + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setLoadingCount((c) => Math.max(0, c - 1));
  }, []);

  return (
    <PageLoadingContext.Provider value={{ isLoading: loadingCount > 0, startLoading, stopLoading }}>
      {children}
    </PageLoadingContext.Provider>
  );
}

/**
 * Hook for components to signal page-level loading.
 * Call startLoading() when beginning an async operation,
 * stopLoading() when done. Multiple components can load
 * simultaneously — the bar shows until all finish.
 */
export function usePageLoading() {
  const context = useContext(PageLoadingContext);
  if (!context) {
    // Graceful fallback if used outside provider
    return { isLoading: false, startLoading: () => {}, stopLoading: () => {} };
  }
  return context;
}
